import React from 'react';
import './less/package.less';
import { Button } from 'antd';


const Package = (props) => {

    const selectItem = (item) => {
        props.parentCallback(item);
    }

    const [filterActive, setFilterActive] = React.useState(0);

    const packages_0 = [1]
    const packages_1 = [1, 2]
    const packages_2 = [1, 2, 3]
    const packages_3 = [1, 1, 1, 1]
    const packages_4 = [1, 1, 1, 1, 1]
    const packages_5 = [1, 1, 1, 1, 1, 1]
    const packages_6 = [1, 1, 1, 1, 1, 1, 1]


    const [packagesItem, setPackageseItem] = React.useState(
        packages_0.map((item, index) =>
            <div key={index} className="ant-col package-block ant-col-xs-24 ant-col-rtl ant-col-md-6">
                <div className="package-block-box active">
                    <div className="package-top-wrapper">
                        <div className="package-name">
                            <span><span><p>برگزاری نامحدود کلاس</p></span></span>
                        </div>
                        <h1 className="package-money"><span><p>30 نفره</p></span></h1>
                    </div>

                    <div className="package-content">
                        <span>
                            <div className="option-row">
                                <h4 className="pricing-money"><span>140,000</span>تومان</h4>

                            </div>
                            <div className="option-row">
                                تعداد شرکت‌کننده هم‌زمان: 30 نفر

        </div>
                            <div className="option-row">
                                برگزاری کلاس به صورت نامحدود

        </div>
                            <div className="option-row">
                                تعداد نامحدود وبینار، کلاس و جلسه

        </div>
                            <div className="option-row">
                                اشتراک تا ۸ وبکم به صورت همزمان
        </div>
                        </span>
                    </div>

                    <i className="package-line"></i>
                    <div className="package-button-wrapper">

                        <Button type="default" className="package-button" onClick={() => selectItem(item)}>انتخاب</Button>
                    </div>
                </div>
            </div>
        )

    );


    const show = (i, set) => {
        setFilterActive(i);
        setPackageseItem(
            set.map((item, index) =>
                <div key={index} className="ant-col package-block ant-col-xs-24 ant-col-rtl ant-col-md-6">
                    <div className="package-block-box active">
                        <div className="package-top-wrapper">
                            <div className="package-name">
                                <span><span><p>برگزاری نامحدود کلاس</p></span></span>
                            </div>
                            <h1 className="package-money"><span><p>30 نفره</p></span></h1>
                        </div>

                        <div className="package-content">
                            <span>
                                <div className="option-row">
                                    <h4 className="pricing-money"><span>140,000</span>تومان</h4>

                                </div>
                                <div className="option-row">
                                    تعداد شرکت‌کننده هم‌زمان: 30 نفر
    
                            </div>
                                <div className="option-row">
                                    برگزاری کلاس به صورت نامحدود
    
                            </div>
                                <div className="option-row">
                                    تعداد نامحدود وبینار، کلاس و جلسه
    
                            </div>
                                <div className="option-row">
                                    اشتراک تا ۸ وبکم به صورت همزمان
                            </div>
                            </span>
                        </div>

                        <i className="package-line"></i>
                        <div className="package-button-wrapper">
                            <Button type="default" className="package-button" onClick={() => selectItem(item)}>انتخاب</Button>
                        </div>
                    </div>
                </div>
            )
        );

    }

    return (
        <div className="package-wrapper">
            <div className="ant-row ant-row-rtl filter-box">

                <Button className={filterActive === 0 ? 'active' : ''} onClick={() => show(0, packages_0)}>رایگان</Button>

                <Button className={filterActive === 1 ? 'active' : ''} onClick={() => show(1, packages_1)}>مدارس و دانشگاه ها</Button>

                <Button className={filterActive === 2 ? 'active' : ''} onClick={() => show(2, packages_2)}>سرویس 1 تا 40 کاربر</Button>

                <Button className={filterActive === 3 ? 'active' : ''} onClick={() => show(3, packages_3)}>سرویس 50 تا 100 کاربر</Button>

                <Button className={filterActive === 4 ? 'active' : ''} onClick={() => show(4, packages_4)}>سرویس 120 تا 200 کاربر</Button>

                <Button className={filterActive === 5 ? 'active' : ''} onClick={() => show(5, packages_5)}>سرویس 210 تا 1000 کاربر</Button>

                <Button className={filterActive === 6 ? 'active' : ''} onClick={() => show(6, packages_6)}>سرویس های وب کنفرانس</Button>

            </div>

            <div className="ant-row ant-row-rtl">
                {packagesItem}
            </div>
        </div>
    );
};

export default Package;